exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._141l_I1xmphlgXtdgTGUYj:before,._1d94gVjYdJ_jf1rU4y7Fa1{color:\"[theme:redDark, default:#a80000]\"!important}._3Ru60IQ-L6bG4PG1B_tA91:before{color:\"[theme:green20, default:#0b6a0b]\"!important}html[dir] ._3Ru60IQ-L6bG4PG1B_tA91:before{margin-bottom:2px}._3s5PMjXLA6fBvCD5F5X4M2{color:\"[theme:green20, default:#0b6a0b]\"!important}._2vJSIBIe_Qk7CcuORhuHJv:before,._2uQ690o8HqTx7Z04SP9OO0{color:\"[theme:themePrimary, default:#0078D4]\"!important}._2QvksTsK5oriJJM-5h8Ce4:before{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"redDark": "_141l_I1xmphlgXtdgTGUYj",
	"redDarkNext": "_1d94gVjYdJ_jf1rU4y7Fa1",
	"snooze": "_3Ru60IQ-L6bG4PG1B_tA91",
	"snoozeNext": "_3s5PMjXLA6fBvCD5F5X4M2",
	"accounts": "_2vJSIBIe_Qk7CcuORhuHJv",
	"accountsNext": "_2uQ690o8HqTx7Z04SP9OO0",
	"accountsRead": "_2QvksTsK5oriJJM-5h8Ce4"
};